/**
 * Loads i18n JSON for the active language and exposes a translate helper as both
 * translationService.t(key) and the global window.t(key, fallback).
 */
class TranslationService {
  constructor() {
    this.dict = {};
    this.lang = "en";
  }

  async load(lang) {
    this.lang = lang;
    try {
      const res = await fetch(`/i18n/${lang}.json`);
      this.dict = res.ok ? await res.json() : {};
    } catch {
      this.dict = {};
    }
    window.t = (key, fallback) => this.t(key, fallback);
    return this.dict;
  }

  /** Dotted-key lookup: t("gallery.back"). Falls back to the key itself. */
  t(key, fallback) {
    const value = key.split(".").reduce((o, k) => (o == null ? o : o[k]), this.dict);
    return value ?? fallback ?? key;
  }
}

export default new TranslationService();
